import { cx } from './ui';

const SIZES = {
  sm: 'size-8 rounded-[0.625rem] text-sm',
  md: 'size-10 rounded-xl text-base',
  lg: 'size-14 rounded-2xl text-xl',
} as const;

/**
 * The store's mark (ADR-123): the logo it uploaded on Branding, on a white tile
 * — logos are drawn for light grounds, and the menu is forest — or, without
 * one, its name's first letter on the Emerald Flow gradient. Never the
 * platform's mark.
 */
export function StoreMark({
  logo,
  name,
  size = 'md',
  className,
}: {
  logo: string | null | undefined;
  name: string;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  if (logo) {
    return (
      <span
        className={cx(
          'inline-flex shrink-0 items-center justify-center overflow-hidden bg-white p-1 shadow-[0_0_0_1px_rgb(0_0_0/0.06),0_4px_14px_rgb(0_0_0/0.18)]',
          SIZES[size],
          className,
        )}
      >
        <img src={logo} alt="" className="max-h-full max-w-full object-contain" />
      </span>
    );
  }

  return (
    <span
      aria-hidden
      style={{ backgroundImage: 'var(--gradient-flow)' }}
      className={cx(
        // Forest on the gradient: white on the Mint end would fail contrast.
        'inline-flex shrink-0 items-center justify-center font-bold text-nav shadow-[0_4px_14px_rgb(0_0_0/0.18)]',
        SIZES[size],
        className,
      )}
    >
      {[...name.trim()][0] ?? ''}
    </span>
  );
}
